import { render } from "./Navbar.vue?vue&type=template&id=7c0ba24e&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=7c0ba24e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c0ba24e"

export default script